import { defaultLocale, locales } from "@mw/shared/i18n";
import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  locales,
  localePrefix: "as-needed",
  defaultLocale,
  localeDetection: true,
  alternateLinks: false,
  localeCookie: {
    // Expire in one year
    maxAge: 60 * 60 * 24 * 365,
  },
});
